/* eslint-disable react/jsx-key */
import React from 'react';
import PropTypes from 'prop-types';
import { useTable, useSortBy, useFilters } from 'react-table';

import { TableBody } from './TableBody';
import { StatsTable } from '../../../../../statspro/js/components/common/stats-table/StatsTable';
import { StatsTableHead } from '../../../../../statspro/js/components/common/stats-table/StatsTableHead';

export const Table = ({ columns, data, modifier, cssClass }) => {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
        useTable(
            {
                columns,
                data
            },
            useFilters,
            useSortBy
        );

    // ===== Render ========================================================= //

    return (
        <StatsTable
            modifier={modifier}
            getTableProps={getTableProps}
            cssClass={cssClass}
            stickyHeader={<StatsTableHead headerGroup={headerGroups[0]} />}
            longCellPos={7}
        >
            <StatsTableHead headerGroup={headerGroups[0]} />
            <TableBody
                rows={rows}
                prepareRow={prepareRow}
                getTableBodyProps={getTableBodyProps}
            />
        </StatsTable>
    );
};

Table.propTypes = {
    columns: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    modifier: PropTypes.string,
    cssClass: PropTypes.string
};
